var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat',{attrs:{"title":_vm.$t('dashboard.sessions.title'),"loading":_vm.loading}},[(_vm.totalResults !== 0)?_c('sessions-chart',{staticStyle:{"width":"100%"},attrs:{"dataKey":_vm.dataKey,"params":_vm.params,"height":200}}):_c('small',[_vm._v(_vm._s(_vm.$t('dashboard.sessions.notActivated')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122b3492","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Sessions.vue
// module id = null
// module chunks = 